import { render, staticRenderFns } from "./video-replay.vue?vue&type=template&id=2be9b77d&scoped=true"
import script from "./video-replay.vue?vue&type=script&lang=js"
export * from "./video-replay.vue?vue&type=script&lang=js"
import style0 from "./video-replay.vue?vue&type=style&index=0&id=2be9b77d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9b77d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2be9b77d')) {
      api.createRecord('2be9b77d', component.options)
    } else {
      api.reload('2be9b77d', component.options)
    }
    module.hot.accept("./video-replay.vue?vue&type=template&id=2be9b77d&scoped=true", function () {
      api.rerender('2be9b77d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/video-replay.vue"
export default component.exports